import { createSlice } from "@reduxjs/toolkit";
import { BaseApiState } from "../../api/axiosConfig";
import {
  deleteRegistryFile,
  fetchRegistry,
  fetchRegistryFiles,
  loadRegistryFiltersData,
} from "../actions/registryAction";
import { RegistryFiltersData } from "../../api/registryApi";
import { FileData } from "../../api/psychologicalLabApi";

export interface RegistryState extends BaseApiState {
  refreshNeeded: boolean;
  loadingRegistry: boolean;
  succeededRegistry: boolean;
  succeededRegistryFiles: boolean;
  succeededDeletedRegistryFile: boolean;
  loadingRegistryFilters: boolean;
  loadingDeleteFile: boolean;
  loadingRegistryFiles: boolean;
  filters: RegistryFiltersData | null;
  registryFiles: FileData[] | null;
}

const registryInitialState: RegistryState = {
  succeededRegistry: false,
  succeededDeletedRegistryFile: false,
  succeededRegistryFiles: false,
  loadingRegistry: false,
  loadingRegistryFiles: false,
  loadingRegistryFilters: false,
  loadingDeleteFile: false,
  refreshNeeded: false,
  loading: false,
  error: false,
  errorMessage: undefined,
  errorDetails: undefined,
  succeeded: false,
  filters: null,
  registryFiles: null,
};

const RegistrySlice = createSlice({
  name: "registry",
  initialState: registryInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegistry.pending, (state) => {
        state.loadingRegistry = true;
        state.succeededRegistry = false;
        state.succeededDeletedRegistryFile = false;
      })
      .addCase(fetchRegistry.rejected, (state) => {
        state.succeededDeletedRegistryFile = false;
        state.loadingRegistry = false;
        state.succeededRegistry = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
      })
      .addCase(fetchRegistry.fulfilled, (state) => {
        state.succeededDeletedRegistryFile = false;
        state.loadingRegistry = false;
        state.succeededRegistry = true;
        state.refreshNeeded = false;
      })
      .addCase(loadRegistryFiltersData.pending, (state) => {
        state.filters = null;
        state.loadingRegistryFilters = true;
      })
      .addCase(loadRegistryFiltersData.rejected, (state) => {
        state.filters = null;
        state.loadingRegistryFilters = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
      })
      .addCase(loadRegistryFiltersData.fulfilled, (state, action) => {
        state.filters = action.payload;
        state.loadingRegistryFilters = false;
        state.succeeded = true;
        state.refreshNeeded = false;
      })
      .addCase(fetchRegistryFiles.pending, (state) => {
        state.loadingRegistryFiles = true;
        state.succeededRegistryFiles = false;
      })
      .addCase(fetchRegistryFiles.rejected, (state) => {
        state.loadingRegistryFilters = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
        state.succeededRegistryFiles = false;
      })
      .addCase(fetchRegistryFiles.fulfilled, (state, action) => {
        state.registryFiles = action.payload;
        state.loadingRegistryFilters = false;
        state.succeededRegistryFiles = true;
        state.refreshNeeded = false;
      })
      .addCase(deleteRegistryFile.pending, (state) => {
        state.succeededRegistry = false;
        state.succeededDeletedRegistryFile = false;
        state.loadingDeleteFile = true;
      })
      .addCase(deleteRegistryFile.rejected, (state) => {
        state.succeededRegistry = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
        state.succeededDeletedRegistryFile = false;
        state.loadingDeleteFile = false;
      })
      .addCase(deleteRegistryFile.fulfilled, (state) => {
        state.succeededRegistry = false;
        state.loadingDeleteFile = false;
        state.succeededDeletedRegistryFile = true;
        state.refreshNeeded = false;
      });
  },
});

export const registryReducer = RegistrySlice.reducer;